import React, { FC } from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { Button, Col, Row, Typography } from 'components';
import { HasAccess } from 'components/common/accessControl';
import { FormattedShippingInfo, ShippingMethodType, ShippingSpeedType } from 'typings/client';
import { CargoIcon, DeleteIcon, EditIcon, FreightIcon, LocationIcon } from 'components/common/icons';
import { useShippingAddress } from './useShippingAddress';
import { AddressAddEditModal } from './../addEdit';
import styles from './styles.module.scss';

const { Text } = Typography;

interface IShippingAddress {
  data: FormattedShippingInfo;
  onDeleteModalOpen: (id: string) => void;
}

export const SHIPPING_SPEED_MAPPING: Record<ShippingSpeedType, string> = {
  STANDARD: 'Standard',
  EXPEDITED: 'Expedited',
  LOCAL_DELIVERY: 'Local Delivery',
};
export const SHIPPING_METHOD_MAPPING: Record<ShippingMethodType, any> = {
  CARGO: {
    icon: <CargoIcon />,
    text: 'Cargo',
  },
  FREIGHT: {
    icon: <FreightIcon />,
    text: 'AirFright',
  },
};

export const ShippingAddress: FC<IShippingAddress> = React.memo((props) => {
  const { data, onDeleteModalOpen } = props;
  const { fullAddress, warehouseName, shippingSpeed, shippingMethod, id } = data;
  const { onUpdateModalOpen, onUpdateModalClose, isUpdateOpen } = useShippingAddress();
  return (
    <>
      <Row className={styles.shipping_address} gutter={[4, 0]} wrap={false}>
        <Col flex={'16px'}>
          <LocationIcon />
        </Col>
        <Col flex={'auto'}>
          <Row gutter={[0, 10]}>
            <Col span={24}>
              <Row justify={'space-between'} gutter={[16, 0]} wrap={false}>
                <Col>
                  <Text className={'font-weight-500'}>{fullAddress}</Text>
                </Col>
                <Col>
                  <Row wrap={false}>
                    <Col>
                      <HasAccess role={PERMISSIONS.clients.shipping_address.delete}>
                        <Button onClick={() => onDeleteModalOpen(id)} icon={<DeleteIcon />} type={'text'} />
                      </HasAccess>
                    </Col>
                    <Col>
                      <HasAccess role={PERMISSIONS.clients.shipping_address.write}>
                        <Button onClick={() => onUpdateModalOpen()} icon={<EditIcon />} type={'text'} />
                      </HasAccess>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            {warehouseName && (
              <Col span={24}>
                <Row>
                  <Col span={24}>
                    <Text className={'font-size-12'}>WAREHOUSE</Text>
                  </Col>
                  <Col span={24}>
                    <Text>{warehouseName}</Text>
                  </Col>
                </Row>
              </Col>
            )}
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  {SHIPPING_METHOD_MAPPING[shippingMethod] && (
                    <Row className={styles.shipping_method_container} align={'middle'}>
                      <Col className={styles.shipping_method}>{SHIPPING_METHOD_MAPPING[shippingMethod].icon}</Col>
                      <Col>
                        <Text>{SHIPPING_METHOD_MAPPING[shippingMethod].text}</Text>
                      </Col>
                    </Row>
                  )}
                </Col>
                {SHIPPING_SPEED_MAPPING[shippingSpeed] && (
                  <Col className={styles.shipping_speed}>
                    <Text type={'secondary'}>{SHIPPING_SPEED_MAPPING[shippingSpeed]}</Text>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <AddressAddEditModal modalState={isUpdateOpen} dataToEdit={data} onModalStateChange={onUpdateModalClose} />
    </>
  );
});
